import React from 'react';

interface PersonSelectOptionProps {
  id?: string;
  grayedOut?: boolean;
  relationship?: string;
  text: string;
  handleClick?: (() => void) | null;
  icon?: string;
  selected?: boolean;
}

export function PersonSelectOption({ 
  id,
  grayedOut = false, 
  relationship = '', 
  text, 
  handleClick = null,
  icon = 'account_circle',
  selected = false
}: PersonSelectOptionProps) {
  const classes = [ 'person-select-option', 'clickable' ];
  const style = {} as React.CSSProperties;

  if (grayedOut) {
    classes.push('grayed-out');
  }

  if (selected) {
    style.backgroundColor = '#eff6ff'; // $background-color-highlight
  }

  return (
    <div className={classes.join(' ')} onClick={handleClick} style={style}>
      <div className="person-select-icon-container">
        <span className="material-symbols-outlined">
          {icon}
        </span>
      </div>
      <div className="person-select-text-container">
        <span className="person-select-text">{text}</span>
        <span className="person-select-subtext">
          {relationship ?? ''}
        </span>
      </div>
      {
        id && (
          <div className="input-container">
            <input 
              id={id}
              type="checkbox" 
              className="person-select-checkbox"
            />
          </div>
        )
      }
    </div>
  );
}
